import { ADD_FOLLOWUP_DATE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export default async function changeFollowupDateOfApt(
    aid: string,
    date: string,
): Promise<{ success: boolean; error?: string }> {
    const response = await fetchWithRefresh(ADD_FOLLOWUP_DATE, {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            mode: 'cors',
            credentials: 'include',
        },
        body: JSON.stringify({ aid, date }),
    });

    const res = await response.json();
    return res;
}
